import './GooglePlay.css';
import { useState, useCallback, useEffect } from 'react';

function isRunningInPWA() {
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
        return true;
    }
    return false;
}

function GooglePlay() {
    const urlParams = new URLSearchParams(window.location.search);
    var isClick = urlParams.get('click') == "1"
    function playClick() {
        if (isClick) {
            window.open("/index.html?pwa=1", "_blank")
            console.log("try open in pwa mode");
        } else {
            const url = new URL(window.location.href);  // 获取当前页面的 URL 对象
            url.searchParams.delete("pwa");  // 删除指定参数
            // 使用 window.location.replace() 来跳转到新 URL
            window.location.replace(url.toString());  // 这将替换当前页面并更新 URL
        }
    }

    function sendEventLog(eventName) {
        var localParams = new Map(Object.entries(JSON.parse(localStorage.getItem("params"))));

        var body = {};
        body["action"] = eventName;
        body["uuid"] = uuid;
        body["first"] = localStorage.getItem("appInstalled") == null;
        body["host"] = window.location.host;
        body["os"] = "android";
        localParams.forEach((value, key) => {
            body[key] = value;
        });

        var content = JSON.stringify(body)
        console.log("sendEventLog: " + content);
        var xhr = new XMLHttpRequest();
        var url = "https://log.cashrush.cc/log";
        xhr.open("POST", url, true);
        xhr.setRequestHeader("Content-type", "application/json");
        xhr.send(content);
    }

    function isChromeBrowser() {
        const ua = navigator.userAgent.toLowerCase();
        const isChrome = ua.indexOf('chrome') > -1;
        const nav = window.navigator;
        const hasCustomHeader = /Google Inc/.test(nav.vendor);
        const hasChromObj = window.chrome;
        return isChrome && hasCustomHeader && hasChromObj
    }

    function openInChrome() {
        const currentURL = window.location.href;
        const npURL = currentURL.replace("https://", "");
        const chromeURL = "intent://" + npURL + "#Intent;package=com.android.chrome;scheme=https;end"
        window.location.href = chromeURL;
    }

    let installPromptEvent = null;
    let beforeinstallpromptAdded = false;
    if (!beforeinstallpromptAdded) {
        window.addEventListener('beforeinstallprompt', (event) => {
            console.log("beforeinstallprompt event")
            event.preventDefault();  // Chrome <= 67 可以阻止显示
            installPromptEvent = event; // 拿到事件的引用
            document.querySelector('#reInstall').disabled = false; // 更新安装 UI，通知用户可以安装
            var loadingElement = document.querySelector('#loading-box');
            loadingElement.style.display = 'none';
        });
        beforeinstallpromptAdded = true;
    }

    let uuid = localStorage.getItem("web_uuid")

    function waitInstall() {
        var popShowElement = document.querySelector('#pop-show');
        var waitDivElement = document.querySelector('#wait-div');
        var spanCountElement = document.querySelector('#count1');
        var waitLoadingDivElement = document.querySelector('#wait-loading-div');
        var waitLoadingStrongElement = document.querySelector('#wait-loading-strong');

        popShowElement.style.display = 'block';

        for (let k = 1; k <= 100; k++) {
            setTimeout(function timer() {
                spanCountElement.innerHTML = k;
                if (k === 100) {
                    waitDivElement.style.display = 'block';
                    waitLoadingDivElement.style.display = 'none';
                    waitLoadingStrongElement.style.display = 'none';
                }
            }, k * 80);
        }
    }

    function WaitClickBtnClick() {
        var installingBtn = document.querySelector('#installing');
        var installingProessElement = document.querySelector('#proess');
        var installingProessCount = document.querySelector('#count');
        var popShowElement = document.querySelector('#pop-show');
        var reInstallBtn = document.querySelector('#reInstall');
        if (!installPromptEvent) {
            popShowElement.style.display = 'none';
            document.body.setAttribute('data-type', 'PLAY');
            return;
        }
        installPromptEvent.prompt();
        installPromptEvent.userChoice.then(choiceResult => {
            if (choiceResult.outcome === 'accepted') {
                console.log('用户已同意添加到桌面');
                // debugger;

                popShowElement.style.display = 'none';

                if (isClick) {
                    document.body.setAttribute('data-type', 'INSTALLING');
                    setTimeout(() => {
                        document.body.setAttribute('data-type', 'PLAY');
                    }, 10000);
                } else {
                    document.body.setAttribute('data-type', 'PLAY');
                }

                installPromptEvent = null;
            } else {
                console.log('用户已取消添加到桌面');
            }
        });

        // 发送按钮点击日志
        sendEventLog("PwaClickInstallBtn") //JSON.stringify(body));
    }

    function InstallPwa() {
        if (true) {
            waitInstall();
            return;
        }
    }

    function onLoad() {
        sendEventLog("PwaLoad");
        console.log('play is fully loaded');
    }

    let isAppInstalledAdded = false;
    if (!isAppInstalledAdded) {
        isAppInstalledAdded = true;
        window.addEventListener('appinstalled', (event) => {
            // 发送日志
            console.log('appinstalled');
            sendEventLog("PwaInstall");
            localStorage.setItem("appInstalled", "1")
        });
    }

    let isLoadListenerAdded = false;
    if (!isLoadListenerAdded) {
        console.log("document.readyState: " + document.readyState);
        if (document.readyState === 'complete') {
            onLoad();
        } else {
            window.addEventListener('load', onLoad);
        }
        isLoadListenerAdded = true;
    }

    useEffect(() => {
        document.body.setAttribute('data-type', 'INSTALL');

        var isChrome = isChromeBrowser();
        if (!isChrome) {
            openInChrome();
        }
        // reInstallBtn.disabled = false;

        const checkPWAInstallation = async () => {
            // 检查浏览器是否支持 getInstalledRelatedApps
            if ('getInstalledRelatedApps' in navigator) {
                try {
                    const relatedApps = await navigator.getInstalledRelatedApps();
                    if (relatedApps.length > 0) {
                        // 如果返回的数组不为空，说明相关 PWA 已安装
                        console.log('已安装的 PWA:', relatedApps);
                    } else {
                        console.log('未检测到已安装的 PWA');
                    }
                } catch (error) {
                    console.error('检查 PWA 安装状态失败:', error);
                }
            } else {
                // 浏览器不支持 getInstalledRelatedApps
                console.log('浏览器不支持 getInstalledRelatedApps API');
            }
        };

        checkPWAInstallation();
    })

    var appName = "JackpotClub Slots"
    var pwaName = urlParams.get("pwaName")
    if (pwaName == "jackpotblitz") {
        pwaName = urlParams.get("pwaName");
        appName = "JackpotClub: Win Real Cash"
        console.log("pwaName: " + pwaName)
    } else {
        pwaName = "default"
    }

    const image1 = "/image/" + pwaName + "/1.jpg"
    const image2 = "/image/" + pwaName + "/2.jpg"
    const image3 = "/image/" + pwaName + "/3.jpg"
    const image4 = "/image/" + pwaName + "/4.jpg"
    const image5 = "/image/" + pwaName + "/5.jpg"

    return (
        <div>
            <div className="template-head">
                <div className="box">
                    <div className="l">
                        <a>
                            <svg className="kOqhQd" aria-hidden="true" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
                                <path fill="none" d="M0,0h40v40H0V0z"></path>
                                <g>
                                    <path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z"
                                        fill="#EA4335"></path>
                                    <path
                                        d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z"
                                        fill="#FBBC04"></path>
                                    <path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4"></path>
                                    <path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z"
                                        fill="#34A853"></path>
                                </g>
                            </svg>
                            <h1>Google Play</h1>
                        </a>
                    </div>
                    <div className="r">
                        <a>
                            <img width="24" src="/image/search.svg" alt="" />
                        </a>
                        <a> <img width="24" src="/image/help.svg" alt="" /></a>
                        <a> <img src="/image/avatar.png" alt="" /></a>
                    </div>
                </div>
            </div>
            <div className="template-bd">
                <div id="loading-box" style={{ display: "none" }}>
                    <div className="mask"></div>
                    <div className="bd">
                        <img width="45" className="rotate" src="/image/loading.svg" />
                        <p>Loading...</p>
                    </div>
                </div>
                <div id="pop-show">
                    <div className="mask"></div>
                    <div className="bd">
                        <strong id="wait-loading-strong"> <img src="/image/lightning.svg" />Install</strong>

                        <div className="loading-ci" id="wait-loading-div">
                            <div className="box"></div>
                            <span id="count1">0</span>%
                        </div>
                        <div className="show-btn" id="wait-div">
                            <div className="active-box">
                                <span><img src="/image/safe.svg" />Effective</span>
                            </div>
                            <button className="btn big" id="click-btn" onClick={WaitClickBtnClick}>Install Now</button>
                        </div>
                    </div>
                </div>
                <div className="main-up">
                    <div className="logo">
                        <div className="box"></div>
                        <img src="/image/icon.png" alt="JackpotClub Slots" />
                    </div>
                    <div className="info">
                        <h1>{appName}</h1>
                        <h2>Game Spin Limited</h2>
                        <p>Verified by App</p>
                    </div>
                </div>
                <ul className="information-list">
                    <li>
                        <strong>
                            4.8
                            <img src="/image/start.png" alt="" />
                        </strong>
                        <p>69K reviews</p>
                    </li>
                    <li>
                        <strong>765K +</strong>
                        <p>Downloads</p>
                    </li>
                    <li>
                        <strong><img className="large" src="/image/18.svg" /></strong>
                        <p>Rated for 18+</p>
                    </li>
                </ul>

                <div className="btn-box shiny">
                    <button id="loading" className="btn">Loading...</button>

                    <button id="reInstall" className="btn" onClick={InstallPwa}>Install</button>

                    <div id="installing" className="btn">
                        <div id="proess"></div>
                        <div className="loading-text">
                            Installing please wait
                            <span className="dots">
                                <span style={{ "--i": 0 }}>.</span>
                                <span style={{ "--i": 1 }}>.</span>
                                <span style={{ "--i": 2 }}>.</span>
                            </span>
                        </div>
                    </div>
                    <button id="play" onClick={playClick} className="btn">
                        Play
                    </button>
                </div>

                <ul className="google-share-btns">
                    <li>
                        <svg className="f70z8e" width="24" height="24" viewBox="0 0 24 24">
                            <path
                                d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z">
                            </path>
                        </svg>
                        <span>Share</span>
                    </li>
                    <li>
                        <svg className="XkAcee" width="24" height="24" viewBox="0 0 24 24">
                            <path fillRule="evenodd" clipRule="evenodd"
                                d="M7 3H17C18.1045 3 19 3.8955 19 5V21L12 18L5 21L5.01075 5C5.01075 3.8955 5.8965 3 7 3ZM12 15.824L17 18V5H7V18L12 15.824ZM13 7V9H15V11H13V13H11V11H9V9H11V7H13Z">
                            </path>
                        </svg>
                        <span>Add to wishlist</span>
                    </li>
                </ul>
                <div className="banner-imgs-box landscape">
                    <ul className="banner-imgs">

                        <li><img src={image1} alt="" /></li>

                        <li><img src={image2} alt="" /></li>

                        <li><img src={image3} alt="" /></li>

                        <li><img src={image4} alt="" /></li>

                        <li><img src={image5} alt="" /></li>

                    </ul>
                </div>

                <div className="introduce">
                    <h2>About this app</h2>
                    <div>Welcome to JackpotClub Slots, where the best online casino slot machines and Vegas slots games are
                        waiting for you!

                        **Long for enjoying the thrills of spinning on casino slot games?
                        **Long for the excitement of hitting JACKPOTS?

                        Spin and have fun at anytime and anywhere with the this best slot app!

                        Download JackpotClub Slots, one of the most popular casino slot games, to enjoy ultimate fun of Las
                        Vegas slot machine game. </div>
                </div>
                <div className="update-box">
                    <h3>Updated on</h3>
                    <p>Mar 13, 2024</p>
                </div>
                <div className="introduce data-safety-box">
                    <h2>Data safety</h2>
                    <p>Safety starts with understanding how developers collect and share your data. Data privacy and security
                        practices may vary based on your use,region, and age. The developer provided this information and may update it
                        over time.</p>
                </div>
                <div className="data-safety-list">
                    <ul>
                        <li>
                            <img src="/image/1.png" alt="" />
                            <div>
                                No data shared with third parties<p><span>Learn more</span> about how developers declare sharing</p>
                            </div>
                        </li>
                        <li>
                            <img src="/image/2.png" alt="" />
                            <div>
                                This app may collect these data types<p>Location, Personal info and 5 others</p>
                            </div>
                        </li>
                        <li>
                            <img src="/image/3.png" alt="" />
                            <div>Data is encrypted in transit</div>
                        </li>
                        <li>
                            <img src="/image/4.png" alt="" />
                            <div>You can request that data be deleted</div>
                        </li>
                    </ul>
                    <p>See details</p>
                </div>

                <div>
                    <img style={{ width: "100%" }} src="/image/b1.jpg" />
                    <img style={{ width: "100%" }} src="/image/b2.jpg" />
                </div>

            </div>
            <div className="template-footer">
                <ul>
                    <li>
                        <a>
                            <p><img width="24" src="/image/game.svg" alt="" /></p>
                            <span>Games</span>
                        </a>
                    </li>
                    <li className="active">
                        <a>
                            <p><img width="24" src="/image/app.svg" alt="" /></p>
                            <span>Apps</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <p><img width="24" src="/image/file.svg" alt="" /></p>
                            <span>Movies</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <p><img width="24" src="/image/book.svg" alt="" /></p>
                            <span>Books</span>
                        </a>
                    </li>
                    <li>
                        <a>
                            <p><img width="24" src="/image/child.svg" alt="" /></p>
                            <span>Kids</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default GooglePlay;